import { mapAlertFilterData } from '../clients/AlertServiceClient';
export function getAlertBulkActionParams(dataTableProps, appliedFilterData, staticFilterData) {
    var _a;
    const selectedAlertIds = (_a = dataTableProps.selectedRowIds) !== null && _a !== void 0 ? _a : [];
    return {
        queryParams: selectedAlertIds.length > 0
            ? undefined
            : mapAlertFilterData(Object.assign(Object.assign({}, appliedFilterData), staticFilterData), {
                sortBy: dataTableProps.sortColumnKey,
                ascending: !dataTableProps.sortColumnDesc,
            }),
        alertIds: selectedAlertIds.length > 0 ? selectedAlertIds : undefined,
    };
}
